export default class extends HTMLElement {
  connectedCallback () {
    this.addEventListener('input', (e) => {
      if (e.target.matches('input[type="email"]')) {
        this.syncRow(e.target.closest('[data-targets="dynamic-list.items"]'))
      }
    })

    this.observer = new MutationObserver(() => this.syncAll())
    this.observer.observe(this, { childList: true, subtree: true })

    this.syncAll()
  }

  disconnectedCallback () {
    this.observer?.disconnect()
  }

  get rows () {
    return [...this.querySelectorAll('[data-targets="dynamic-list.items"]')]
  }

  syncAll () {
    this.rows.forEach((row) => this.syncRow(row))

    const addButton = this.querySelector('[data-role="add-recipient"]')

    if (addButton) {
      addButton.classList.toggle('hidden', this.rows.length >= parseInt(this.dataset.maxItems || '10', 10))
    }
  }

  syncRow (row) {
    if (!row) return

    const email = row.querySelector('input[type="email"]')?.value || ''
    const line = row.querySelector('[data-role="include-pdf-line"]')

    if (!line) return

    const domain = email.split('@')[1]?.trim()?.toLowerCase()
    const internalDomain = (this.dataset.internalDomain || 'lwha.com').toLowerCase()
    const isExternal = !!domain && domain !== internalDomain

    line.classList.toggle('hidden', !isExternal)

    if (!isExternal) {
      const checkbox = line.querySelector('input[type="checkbox"]')

      if (checkbox) checkbox.checked = false
    }
  }
}
